import { graphql } from '@/generated/gql';

export const DEMAND_CASE_RELEASE_MUTATION = graphql(/* GraphQL */ `
  mutation DemandCaseRelease($id: UUID!, $data: TsrctReleaseNegotiationCasesInput!) {
    tesseract {
      demand(id: $id) {
        releaseNegotiationCases(data: $data)
      }
    }
  }
`);
